import React, { useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid } from '@material-ui/core';

import LinearProgress from '@material-ui/core/LinearProgress';

import {
  NumberOfStudents,
  NumberOfAlumni,
  NumberOfAdmins,
  TotalNumberOfUsers,
  TotalNumberOfOffers,
  NumberOfApplications,
  PieSchoolDistribution,
  PieMajorDistribution,
  PieAlumniVsStudents,
  ChartSeekersPerSchool,
  PieSeekersVsNonSeekers,
  PieSeekersDistribution,
  ChartSeekersPerMajor,
  ChartApplicationsPerSchool,
  ChartApplicationsPerMajor,
  CompaniesTable,
  OffersTable,
  ApplicationsTable,
  UsersTable,
  TipsTable,
  ChartOffersPerMonth,
  ChartApplicationsPerMonth,
  ConnectionTraffic

} from './components';
import { getDashboardData } from '../../utils/requests'
import PropTypes from "prop-types";

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4)
  }
}));


let data;



const Dashboard = (props) => {
  const classes = useStyles();

  const { history } = props;
  const [isLoading, setIsLoading] = useState(true);
  function getData(){
    return getDashboardData(history)
      .then((res) => {
        if (res){
          data = res;

          setIsLoading(false);

        } else{
          alert('An arror happened while fetching for data');
          history.push('/sign-in')
        }
      })
  }
  getData()
  return (
    <div>
      {(isLoading)?
      <div style={{marginTop:5}}>
        <LinearProgress />
      </div>
        :
        <div className={classes.root}>
          <Grid
            container
            spacing={4}
          >
            <Grid
              item
              lg={3}
              sm={3}
              xl={3}
              xs={12}
            >
              <NumberOfStudents data={data.numberOfStudents}/>
            </Grid>
            <Grid
              item
              lg={3}
              sm={3}
              xl={3}
              xs={12}
            >
              <NumberOfAlumni data={data.numberOfAlumni}/>
            </Grid>

            <Grid
              item
              lg={3}
              sm={3}
              xl={3}
              xs={12}
            >
              <NumberOfAdmins data={data.numberOfAdmins}/>
            </Grid>
            <Grid
              item
              lg={3}
              sm={3}
              xl={3}
              xs={12}
            >
              <TotalNumberOfUsers data={data.numberOfStudents + data.numberOfAlumni}/>
            </Grid>
            <Grid
              item
              lg={6}
              sm={6}
              xl={6}
              xs={12}
            >
              <TotalNumberOfOffers data={data.numberOfOffers} />
            </Grid>
            <Grid
              item
              lg={6}
              sm={6}
              xl={6}
              xs={12}
            >
              <NumberOfApplications data={data.numberOfApplication} />
            </Grid>
            <Grid
              item
              lg={12}
              sm={12}
              xl={12}
              xs={12}
            >
              <ConnectionTraffic data={data.usersWeeklyTraffic}/>
            </Grid>
            <Grid
              item
              lg={6}
              md={6}
              xl={6}
              xs={12}
            >
              <PieMajorDistribution data={data.usersMajorDistribution}/>
            </Grid>
            <Grid
              item
              lg={3}
              md={3}
              xl={3}
              xs={12}
            >
              <PieSchoolDistribution data={data.usersSchoolDistribution}/>
            </Grid>

            <Grid
              item
              lg={3}
              md={3}
              xl={3}
              xs={3}
            >
              <PieAlumniVsStudents data={{alumni:data.numberOfAlumni, students:data.numberOfStudents}}/>
            </Grid>
            <Grid
              item
              lg={6}
              md={6}
              xl={6}
              xs={12}
            >
              <ChartSeekersPerSchool data={data.seekersPerSchool}/>
            </Grid>
            <Grid
              item
              lg={6}
              md={6}
              xl={6}
              xs={6}
            >
              <Grid
                container
                spacing={4}
              >
                <Grid
                  item
                  lg={6}
                  md={6}
                  xl={6}
                  xs={6}
                >
                  <PieSeekersVsNonSeekers data={data.seekersVsNonSeekers}/>
                </Grid>
                <Grid
                  item
                  lg={6}
                  md={6}
                  xl={6}
                  xs={6}
                >
                  <PieSeekersDistribution data={data.seekersPerStanding}/>
                </Grid>
              </Grid>


            </Grid>
            <Grid
              item
              lg={12}
              md={12}
              xl={12}
              xs={12}
            >
              <ChartSeekersPerMajor data={data.seekersPerMajor}/>
            </Grid>
            <Grid
              item
              lg={6}
              md={6}
              xl={6}
              xs={12}
            >
              <ChartApplicationsPerSchool data={data.applicationsPerSchool}/>
            </Grid>
            <Grid
              item
              lg={6}
              md={6}
              xl={6}
              xs={12}
            >
              <ChartApplicationsPerMajor data={data.applicationsPerMajor}/>
            </Grid>
            <Grid
              item
              lg={6}
              md={6}
              xl={6}
              xs={12}
            >
              <ChartOffersPerMonth data={data.offersMonthlyTraffic}/>
            </Grid>
            <Grid
              item
              lg={6}
              md={6}
              xl={6}
              xs={12}
            >
              <ChartApplicationsPerMonth data={data.applicationsMonthlyTraffic}/>
            </Grid>
            <Grid
              item
              lg={12}
              md={12}
              xl={12}
              xs={12}
            >
              <UsersTable data={data.users}/>
            </Grid>
            <Grid
              item
              lg={6}
              md={6}
              xl={6}
              xs={12}
            >
              <ApplicationsTable data={data.applications}/>
            </Grid>
            <Grid
              item
              lg={6}
              md={6}
              xl={6}
              xs={12}
            >
              <CompaniesTable data={data.companies}/>
            </Grid>
            <Grid
              item
              lg={12}
              md={12}
              xl={12}
              xs={12}
            >
              <OffersTable data={data.offers}/>
            </Grid>
            <Grid
              item
              lg={12}
              md={12}
              xl={12}
              xs={12}
            >
              <TipsTable data={data.tips}/>
            </Grid>
          </Grid>
        </div>

      }
    </div>
  );
};

Dashboard.propTypes = {
  history: PropTypes.object
};

export default Dashboard;
